/* global G */
import { curry, isStr } from 'lib/util'
import locations from '@model/xEcoApm/collection/location'

/**
 * Returns the list of available locations.
 *
 * @param module - app module
 * @param component - action component
 * @param eventOrKey
 * @returns {Array} countries
 */
const listLocationValues = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  eventOrKey: Gaia.PlatformEvent | string,
): { key: string, value: string }[] => {
  const key = isStr(eventOrKey) ? eventOrKey : eventOrKey?.detail?.key
  const scope = key ? locations.filter(item => item.key === key) : locations

  return scope.map(item => ({
    ...item,
    value: module[G.ADAPTER][G.INTL]._t(
      `value.location.${item.key}`,
      {
        ns: 'apmGo',
        _key: `value.location.${item.key}`,
        defaultValue: item.value,
      },
    ) as string,
  }))
}

export default curry(listLocationValues)
